import { useRef } from "react";
import {
  DraftRunStatus,
  IWorkerProgress,
} from "store/queries/contractModelDrafts";

import { NO_REMEMBERED_PROGRESS, rememberProgress } from "./progressModel";

/**
 * CLE-2811 — the worker's progress for the pass in flight, kept through `worker_returned` (when the
 * worker has already cleared it) so nothing on the page blinks out just before the result arrives. See
 * `rememberProgress`. The fold runs during render and is idempotent.
 */
export const useLiveProgress = (run: {
  status: DraftRunStatus;
  versionNo: number;
  progress: IWorkerProgress | null;
}): IWorkerProgress | null => {
  const memory = useRef(NO_REMEMBERED_PROGRESS);
  memory.current = rememberProgress(memory.current, run);
  return memory.current.progress;
};
